<p-toast position="bottom-right"></p-toast>
<p-confirmDialog appendTo="body"></p-confirmDialog>
<app-customer-sidebar>
  <app-crud-table body [crudService]="crudService"
                   [transPartKey]="'trader'" [fieldId]="'code'" [fieldName]="'code'"
                   [tableConfig]="tableConfig" [newRecord]="newRecord"
                   [(formRecord)]="formRecord" [formConfig]="formConfig"
                   [settingsFormLoadingProgressValue]="settingsFormLoadingProgressValue"
                   [formLoading]="formLoading"
                   [prepareForEdit]="prepareRecordForEdit" [prepareForClone]="prepareRecordForClone"
                   [writeRoles]="CCRoles.ROLES_CUSTOMER_WRITE_TRADER" [totalRecords]="totalRecords"
  ></app-crud-table>
</app-customer-sidebar>
